module.exports = {
  appName: 'Ford Fleet',
  calendarColor: 'blue',
  globalSupportEmail: 'fleet@ford.com',
  footerLogo: false,
  favicon: 'favicon-generic.svg',
}
